/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  EntityId,
  List,
  MemberContentPermission,
  MemberRole,
  MemberRoleOrGuest,
  MemberSitePermission,
  OrganizationMember,
  OrganizationTeam,
  SiteType,
  TeamMember,
} from "./data-contracts";

/**
 * @description Lists the members of the organization. Guests can list members too, but the list they get leaves out every guest, themselves included, and filtering by the `guest` role returns no one.
 * @tags organization-members
 * @name ListMembersInOrganizationById
 * @summary List all organization members
 * @request GET:/orgs/{organizationId}/members
 * @secure
 */

// @ts-ignore
export const listMembersInOrganizationById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * An order for the items in the list
     * @default "desc"
     */
    order?: "asc" | "desc";
    /** The role to filter the list by */
    role?: MemberRole | "guest";
    /** A query to filter the list by display name and email */
    search?: string;
    /**
     * The property to sort the list by
     * @default "joinedAt"
     */
    sort?: "joinedAt" | "lastSeenAt" | "name";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: OrganizationMember[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/members",
  method: "get",
  streaming: false,
  tags: ["organization-members"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns a member of the organization. Guests can get any member who isn't a guest, and themselves. Another guest is reported as not found.
 * @tags organization-members, critical
 * @name GetMemberInOrganizationById
 * @summary Get an organization member by its ID
 * @request GET:/orgs/{organizationId}/members/{userId}
 * @secure
 */

// @ts-ignore
export const getMemberInOrganizationById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: OrganizationMember;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/members/{userId}",
  method: "get",
  streaming: false,
  tags: ["organization-members", "critical"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * No description
 * @tags organization-members
 * @name UpdateMemberInOrganizationById
 * @summary Update an organization member
 * @request PATCH:/orgs/{organizationId}/members/{userId}
 * @secure
 */

// @ts-ignore
export const updateMemberInOrganizationById: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The role of a member in an organization, null for guests */
    role?: MemberRoleOrGuest;
    /** Disable or re-enable the member. Only members disabled by an admin can be re-enabled. */
    disabled?: boolean;
  };
  RequestHeaders: {};
  ResponseBody: OrganizationMember;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/members/{userId}",
  method: "patch",
  streaming: false,
  tags: ["organization-members"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Users cannot remove their own membership. Ask another organization admin to remove it.
 * @tags organization-members
 * @name RemoveMemberFromOrganizationById
 * @summary Remove an organization member or request an organization admin to do it
 * @request DELETE:/orgs/{organizationId}/members/{userId}
 * @secure
 */

// @ts-ignore
export const removeMemberFromOrganizationById: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 202 | 204 | 205;
} = {
  route: "/orgs/{organizationId}/members/{userId}",
  method: "delete",
  streaming: false,
  tags: ["organization-members"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organization-members
 * @name UpdateOrganizationMemberLastSeenAt
 * @summary Update an organization member last seen at
 * @request POST:/orgs/{organizationId}/ping
 * @secure
 */

// @ts-ignore
export const updateOrganizationMemberLastSeenAt: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    /** A JTW token containing the claims to attach to this user. */
    gitbookVisitorClaims?: string;
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/ping",
  method: "post",
  streaming: false,
  tags: ["organization-members"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organization-members
 * @name SetUserAsSsoMemberForOrganization
 * @summary Set a user as an SSO member of an organization
 * @request POST:/orgs/{organizationId}/members/{userId}/sso
 * @secure
 */

// @ts-ignore
export const setUserAsSSOMemberForOrganization: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: OrganizationMember;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/members/{userId}/sso",
  method: "post",
  streaming: false,
  tags: ["organization-members"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organization-members
 * @name ListSpacesForOrganizationMember
 * @summary List an organization member space permissions
 * @request GET:/orgs/{organizationId}/members/{userId}/spaces
 * @secure
 */

// @ts-ignore
export const listSpacesForOrganizationMember: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * An order for the items in the list
     * @default "desc"
     */
    order?: "asc" | "desc";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: MemberContentPermission[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/members/{userId}/spaces",
  method: "get",
  streaming: false,
  tags: ["organization-members"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organization-members, internal
 * @name ListSitesForOrganizationMember
 * @summary List all organization sites and the specified member's access level for each. Includes sites the member does not yet have access to, so administrators can grant access if needed.
 * @request GET:/orgs/{organizationId}/members/{userId}/sites
 * @secure
 */

// @ts-ignore
export const listSitesForOrganizationMember: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * An order for the items in the list
     * @default "desc"
     */
    order?: "asc" | "desc";
    /** Filter sites by their title */
    title?: string;
    /** Filter by site type */
    type?: SiteType[];
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: MemberSitePermission[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/members/{userId}/sites",
  method: "get",
  streaming: false,
  tags: ["organization-members", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organization-members
 * @name ListTeamsForOrganizationMember
 * @summary List all organization member teams
 * @request GET:/orgs/{organizationId}/members/{userId}/teams
 * @secure
 */

// @ts-ignore
export const listTeamsForOrganizationMember: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** If provided, only teams whose name contains the given parameter will be returned. Case insensitive. */
    title?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: {
      team: OrganizationTeam;
      member: TeamMember;
    }[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/members/{userId}/teams",
  method: "get",
  streaming: false,
  tags: ["organization-members"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
